import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../TextField';

const propTypes = {
  textFieldProps: PropTypes.object,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  noValidation: PropTypes.bool,
  showValidationOnFocus: PropTypes.bool,
  showValid: PropTypes.bool,
  showInvalid: PropTypes.bool,
  showInlineValidation: PropTypes.bool,
};

const defaultProps = {
  textFieldProps: null,
  showInlineValidation: true,
  showValid: true,
  showValidationOnFocus: false,
  showInvalid: true,
  noValidation: false,
};

const ReduxFormTextField = props => {
  const {
    input,
    meta,
    noValidation,
    showValidationOnFocus,
    showValid,
    showInvalid,
    showInlineValidation,
  } = props;
  const { touched, valid, invalid, asyncValidating, error, active } = meta;
  const validate =
    !noValidation && (!active || showValidationOnFocus) && touched && !asyncValidating;
  const isInvalid = validate && invalid && showInvalid;
  const isValid = validate && valid && showValid;

  return (
    <TextField
      {...props.textFieldProps}
      name={input.name}
      onBlur={input.onBlur}
      onFocus={input.onFocus}
      onChange={input.onChange}
      isInvalid={isInvalid}
      isValid={isValid}
      errorMsg={showInlineValidation ? error : ''}
      isLoading={asyncValidating}
      value={input.value}
    />
  );
};

ReduxFormTextField.propTypes = propTypes;
ReduxFormTextField.defaultProps = defaultProps;

export default ReduxFormTextField;



// WEBPACK FOOTER //
// ../ui-components/components/ReduxFormTextField/index.jsx